/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { PALETTE } from "styles/base/variables";

interface IconButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
  title?: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const styleDisabled = css`
  svg {
    stroke: ${PALETTE.iconDisabled};
  }
`;
const styleAbled = css`
  cursor: pointer;
  svg:hover {
    stroke: ${PALETTE.primary};
  }
`;

function IconButton({
  children,
  disabled,
  onClick,
  ...props
}: IconButtonProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      css={css`
        background: none;
        border: none;
        ${disabled ? styleDisabled : styleAbled}
      `}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
}

export default IconButton;
